import { createFileRoute } from "@tanstack/react-router";
import { SEO } from "@/features/marketing/seo";
import { SeatingTool } from "@/features/marketing/tools/seating-tool";

export const Route = createFileRoute("/_marketing/$lang/wedding-seating-chart")({
  head: SEO.seating,
  component: SeatingTool,
});
